import { Link } from "react-router-dom";
import { usePageMeta } from "./Common";

const NotFound = () => {
  usePageMeta("Page Not Found — English for Leaders", undefined, "/404", {
    noindex: true,
  });

  return (
    <div className="mx-auto max-w-7xl px-6 py-28 lg:px-10" data-testid="not-found-page">
      <p className="text-xs font-bold uppercase tracking-[0.28em] text-navy/60">Page not found</p>
      <h1 className="mt-4 font-display text-4xl tracking-tight text-navy sm:text-5xl">
        This page has moved on.
      </h1>
      <p className="mt-4 max-w-xl text-base text-charcoal/75">
        The page you are looking for does not exist. Head back to the homepage or explore the site.
      </p>
      <Link
        to="/"
        data-testid="not-found-home-link"
        className="mt-8 inline-flex items-center gap-2 rounded-sm bg-crimson px-7 py-3.5 text-sm font-bold text-white transition-colors hover:bg-crimson-dark"
      >
        Back to Home
      </Link>
    </div>
  );
};

export default NotFound;
